import { querySelector } from 'kagekiri';
import { ToastSlot, ToastStatus } from '../wrappers';
import { transformTag } from './helpers';
const getToaster = () => {
    const toaster = querySelector(transformTag('iress-toaster'));
    if (toaster)
        return toaster;
    console.warn('Iress Design System - No toaster element is in the page');
    return null;
};
const createActionsSlot = (actions) => {
    const actionsSlot = document.createElement('div');
    actionsSlot.setAttribute('slot', ToastSlot.Actions);
    actionsSlot.appendChild(actions);
    return actionsSlot;
};
const success = (toastObj) => notify(ToastStatus.Success, toastObj);
const error = (toastObj) => notify(ToastStatus.Error, toastObj);
const notify = (status, obj) => {
    const { content, headingLevel, headingText, actions, dataTestId, timeout, dismissible, toaster, } = obj || {};
    const toasterEl = toaster || getToaster();
    if (toasterEl) {
        let actionsObject = {};
        if (actions)
            actionsObject = {
                actions: createActionsSlot(actions),
            };
        const toastObj = Object.assign({ content: content, headingLevel: headingLevel, headingText: headingText, dataTestId: dataTestId, timeout: timeout, dismissible: dismissible }, actionsObject);
        toasterEl[status](toastObj);
    }
};
export const toast = {
    success: success,
    error: error,
};
//# sourceMappingURL=toast.helpers.js.map